<template>
    <div class='demo-banner'>
        <div><span class='please-note'>PLEASE NOTE:</span> This is a demonstration site for itim's e-commerce platform. No orders will be fulfilled.</div>
    </div>
</template>

<style lang="scss" scoped>
.demo-banner{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--black);
    color: white;
    font-size: 0.8rem;
    height: var(--banner-height);
    
    @media(max-width: 768px){
       padding-top: 5px;
       padding-bottom: 5px;
       height: auto;
    }
}
.please-note{
    font-weight: 600;
}
</style>